import IconButton from "@material-ui/core/IconButton";
import UtilsFncs from "../../utils/UtilsFncs.js";
import { FileCopy, Mail } from "@mui/icons-material";

export default function EmailWithCopyAndSend({
  email = "",
  showSend = true,
  showCopy = true,
}) {
  return (
    email &&
    email.trim() > "" && (
      <>
        {email}{" "}
        {showSend && (
          <IconButton size="small" href={"mailto:" + email} target="_blank">
            <Mail fontSize="small" />
          </IconButton>
        )}
        {showCopy && (
          <IconButton
            title="Copiar"
            size="small"
            onClick={() => {
              UtilsFncs.CopyToClipboard(email);
            }}
          >
            <FileCopy fontSize="small" />
          </IconButton>
        )}
      </>
    )
  );
}
